import React from "react";
export default function UserManagement() {
  return <div>User Management Page</div>;
}
